// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-doc-modal-main-container {
  position: relative;
  padding: 0.5rem 0.5rem;
}
.add-doc-modal-main-container .add-doc-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
}
.add-doc-modal-main-container .add-doc-modal .add-doc-modal-form-title {
  text-align: center;
  margin: 0;
  flex: 1 1;
}
.add-doc-modal-main-container .add-doc-modal .add-doc-modal-form-close-button {
  position: absolute;
  right: 20px;
  font-size: 24px;
  background: transparent;
  border: none;
  color: #333;
  cursor: pointer;
  z-index: 2;
  width: 30px;
  height: 30px;
  border-radius: 0.25rem;
}
.add-doc-modal-main-container .add-doc-modal .add-doc-modal-form-close-button:hover {
  color: #333;
  background: #f5f5f5;
}
.add-doc-modal-main-container .doc-form {
  padding: 1rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.add-doc-modal-main-container .doc-form label {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  color: #333;
  gap: 0.5rem;
}
.add-doc-modal-main-container .doc-form label .required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.add-doc-modal-main-container .doc-form label input,
.add-doc-modal-main-container .doc-form label textarea {
  padding: 0.75rem 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}
.add-doc-modal-main-container .doc-form label input:focus,
.add-doc-modal-main-container .doc-form label textarea:focus {
  border-color: var(--primary-color);
  outline: none;
}
.add-doc-modal-main-container .doc-form label input:disabled,
.add-doc-modal-main-container .doc-form label textarea:disabled {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}
.add-doc-modal-main-container .doc-form label textarea {
  min-height: 100px;
  resize: vertical;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button {
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
  opacity: 0.6;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:disabled:hover {
  background-color: #a0aec0;
  transform: none;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:first-child {
  background-color: var(--primary-color);
  color: white;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:first-child:hover {
  background-color: #0056b3;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:last-child {
  background-color: #f1f1f1;
  color: #333;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:last-child:hover {
  background-color: #ddd;
}`, "",{"version":3,"sources":["webpack://./src/pages/DocRequestForm/DocRequestForm.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EAGA,sBAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;EACA,kBAAA;AADJ;AAGI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;AADN;AAII;EACE,kBAAA;EAEA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAHN;AAIM;EACE,WAAA;EACA,mBAAA;AAFR;AAOE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AALJ;AAOI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;AALN;AAOM;EACE,cAAA;EACA,oBAAA;AALR;AAQM;;EAEE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AANR;AAQQ;;EACE,kCAAA;EACA,aAAA;AALV;AAQQ;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AALV;AASM;EACE,iBAAA;EACA,gBAAA;AAPR;AAWI;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AATN;AAWM;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AATR;AAWQ;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AATV;AAWU;EACE,yBAAA;EACA,eAAA;AATZ;AAaQ;EACE,sCAAA;EACA,YAAA;AAXV;AAaU;EACE,yBAAA;AAXZ;AAeQ;EACE,yBAAA;EACA,WAAA;AAbV;AAeU;EACE,sBAAA;AAbZ","sourcesContent":[".add-doc-modal-main-container {\r\n  position: relative;\r\n  //padding: 1.5rem;\r\n  //padding:1.5rem 1.5rem;\r\n  padding: 0.5rem 0.5rem;\r\n\r\n  .add-doc-modal {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 20px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    position: relative;\r\n\r\n    .add-doc-modal-form-title {\r\n      text-align: center;\r\n      margin: 0;\r\n      flex: 1;\r\n    }\r\n\r\n    .add-doc-modal-form-close-button {\r\n      position: absolute;\r\n      //top: 25px;\r\n      right: 20px;\r\n      font-size: 24px;\r\n      background: transparent;\r\n      border: none;\r\n      color: #333;\r\n      cursor: pointer;\r\n      z-index: 2;\r\n      width: 30px;\r\n      height: 30px;\r\n      border-radius: 0.25rem;\r\n      &:hover {\r\n        color: #333;\r\n        background: #f5f5f5;\r\n      }\r\n    }\r\n  }\r\n\r\n  .doc-form {\r\n    padding: 1rem;\r\n    border-radius: 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.2rem;\r\n\r\n    label {\r\n      display: flex;\r\n      flex-direction: column;\r\n      font-weight: 600;\r\n      color: #333;\r\n      gap: 0.5rem;\r\n\r\n      .required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n\r\n      input,\r\n      textarea {\r\n        padding: 0.75rem 1rem;\r\n        border: 1px solid #ccc;\r\n        border-radius: 6px;\r\n        font-size: 1rem;\r\n        transition: border-color 0.3s ease;\r\n\r\n        &:focus {\r\n          border-color: var(--primary-color);\r\n          outline: none;\r\n        }\r\n\r\n        &:disabled {\r\n          background-color: #e9ecef;\r\n          color: #6c757d;\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n\r\n      textarea {\r\n        min-height: 100px;\r\n        resize: vertical;\r\n      }\r\n    }\r\n\r\n    .add-doc-form-actions {\r\n      display: flex;\r\n      justify-content: flex-end;\r\n      gap: 1rem;\r\n\r\n      button {\r\n        padding: 0.6rem 1.2rem;\r\n        border: none;\r\n        border-radius: 6px;\r\n        font-size: 1rem;\r\n        cursor: pointer;\r\n        transition: background 0.3s ease;\r\n\r\n        &:disabled {\r\n          background-color: #a0aec0;\r\n          cursor: not-allowed;\r\n          opacity: 0.6;\r\n\r\n          &:hover {\r\n            background-color: #a0aec0;\r\n            transform: none;\r\n          }\r\n        }\r\n\r\n        &:first-child {\r\n          background-color: var(--primary-color);\r\n          color: white;\r\n\r\n          &:hover {\r\n            background-color: #0056b3;\r\n          }\r\n        }\r\n\r\n        &:last-child {\r\n          background-color: #f1f1f1;\r\n          color: #333;\r\n\r\n          &:hover {\r\n            background-color: #ddd;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
